import React from 'react';
import { MedicationRequestOutputDto } from 'graphql/generated/remote-schema-hasura';
import moment from 'moment';
import { MEDICATION_DATE_FORMAT } from 'utilities/dateHelper';
import ButtonComponent from 'components/button/buttonComponent';
import { ReactComponent as ChevronLeftIcon } from 'assets/icons/chevron-left.svg';

type MedicationRowProps = MedicationRequestOutputDto & {
  setAddress: (address: string) => void;
};

const MedicationRow: React.FC<MedicationRowProps> = ({
  ndc,
  pharmacyAddress,
  displayName,
  activeIngredUnit,
  activeNumeratorStrength,
  quantity,
  expectedSupplyDuration,
  requestedAt,
  setAddress,
}) => {
  const start = moment(requestedAt).format(MEDICATION_DATE_FORMAT);
  const end = moment(requestedAt)
    .subtract(-1 * Number(expectedSupplyDuration?.value || 0), 'days')
    .format(MEDICATION_DATE_FORMAT);
  return (
    <div className="hidden desktop:grid gap-2.5 border border-transparent border-t-gray-opacity-15 grid-cols-15 w-full px-30 py-2.5 text-med-gray-3 text-base font-medium">
      <div className="col-span-2 flex items-center">
        <p className="text-neutral-800 break-words min-w-0">{displayName}</p>
      </div>
      <div className="col-span-2 flex items-center">
        {activeNumeratorStrength || '-'}
      </div>
      <div className="col-span-2 flex items-center">
        {expectedSupplyDuration?.value ?? '-'}
      </div>
      <div className="col-span-1 flex items-center">
        {quantity?.value || '-'}
      </div>
      <div className="col-span-2 flex items-center">
        {activeIngredUnit ?? '-'}
      </div>
      <div className="col-span-2 flex items-center">{ndc ?? '-'}</div>
      <div className="col-span-2 flex flex-col text-left items-center">
        <p className="w-full mt-auto">Start: {start}</p>
        <p className="w-full mb-auto">End: {end}</p>
      </div>
      <div className="col-span-2 flex">
        {pharmacyAddress ? (
          <ButtonComponent
            testID={`pharmacy-${ndc}`}
            type="underline"
            className="text-xs my-auto !w-auto"
            iconPosition="right"
            onClick={() => setAddress(pharmacyAddress)}
            Icon={() => (
              <ChevronLeftIcon className="w-[6px] h-[12px] rotate-180" />
            )}
          >
            Show on Map
          </ButtonComponent>
        ) : (
          'No address'
        )}
      </div>
    </div>
  );
};

export default MedicationRow;
